import { useContext } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { GameContext } from '../../App'
import CardData from '../../game/Card'

const Button = styled.button`
    height: 90px;
    width: 120px;
    text-transfrom: capitalize;
`

function PlayButton({ selected }) {
    const { dispatch } = useContext(GameContext)
    return (
        <Button onClick={() => dispatch({ type: 'PLAY_CARD', payload: { card: selected }})}>Play</Button>
    )
}

PlayButton.propTypes = {
    selected: PropTypes.instanceOf(CardData)
}

export default PlayButton